export const rawApiUrl = process.env.REACT_APP_DEV_BACK_END_BASE_URL;
export const BuildType = process.env.REACT_APP_BUILD_TYPE;

export const ApiURL =
	rawApiUrl && rawApiUrl.includes('https://') ? rawApiUrl : `https://${rawApiUrl}`;
export const isProductionBuild = BuildType === 'production';
